import React, { Component } from 'react';
import { isEmpty, size } from 'lodash';
import { Alert, Box, Button, FormHelperText, Grid, Typography } from '@mui/material';
import Dialog from '../../common/Dialog';
import EquipDemandLineForm from './EquipDemandLineForm';
import { AddCircleOutlineRounded } from '@mui/icons-material';
import InputText from '../../common/Form';
import DatePickerCmp from '../../common/DatePicker';
import axios from 'axios';
import Spinner from '../../common/Spinner';
import { oneWeek } from '../../../utils/statsFunctions';


class EquipDemandUpdateLine extends Component {
    state = { 
        demand_start_date: new Date(),
        demand_end_date: new Date(),
        demand_remarks: "",
        demand_equipements: [
            {
                line_equipement: "",
                line_quantity: "",
                line_remarks: "",
                line_equipementDisplay: {value: "", label: ""}
            }
        ],
        errors: [
            {
                line_equipement: "",
                line_quantity: "",
                // line_remarks: ""
            }
        ],
        EQUIPEMENTS: [],
        fetching : true,
    }
    componentDidMount = async () => {
        console.log('===============LOAN_DEMANDS=====================');
        console.log(this.props.DEMAND);
        console.log('====================================');
        const res = await axios.get('/equipements/get/all/available')
        console.log({res});
        if(!res.data.error){
            this.setState({
                EQUIPEMENTS: res.data,
                fetching: false
            })
        } else {
            this.setState({
                fetching: false
            })
        }        

    }

    handleAddForm = () => {
        
        this.setState({
            demand_equipements: [
                ...this.state.demand_equipements,
                {
                    // demand_id: "", for updates ?
                    line_equipement: "",
                    line_quantity: "",
                    line_remarks: "",
                    line_equipementDisplay: {value: "", label: ""}
                }
            ],
            
            errors:[
                ...this.state.errors, {
                    line_equipement: "",
                    line_quantity: "",
                    // line_remarks: ""
                }
            ]
            
        })
    }
    createAddForm = () => {
        const { demand_equipements } = this.state
        
        let selected = demand_equipements.map( item => item.line_equipement)
        console.log('====================================');
        console.log({selected});
        console.log('====================================');
        let tab = []
        let total = 0
        // for(let i = 0; i < size(demand_equipements); i++){
            demand_equipements.map((art, i) => {
                total += art.line_quantity
                
                tab.push(
                    <EquipDemandLineForm
                        {...art}
                        EQUIPEMENTS={ this.state.EQUIPEMENTS && this.state.EQUIPEMENTS}
                        selected={selected}
                        errors={this.state.errors[i]} 
                        handleChange={this.handleChangeArticles} 
                        handleChangeCreatable={this.handleChangeCreatable} 
                        deleteLine={this.deleteLine} 
                        index={i} 
                    />
                )
            })
            
        // }
        return {tab, total}
    }

    deleteLine = (index) => {
        this.setState({
            demand_equipements: [
                ...this.state.demand_equipements.slice(0,index),
                ...this.state.demand_equipements.slice(index +1),
            ],
            errors: [
                ...this.state.errors.slice(0,index),
                ...this.state.errors.slice(index +1),
            ]
            ,
        })

    }
    handleChangeArticles = (name, value, index) => {
        console.log('=========== handleChangeArticles ===============');
        console.log({name, value, index});
        
        let cpArticles = [].concat(this.state.demand_equipements)  
        if( name == "line_quantity" && value !== ""){
            cpArticles[index][name] = parseInt(value) 
        } else {
            cpArticles[index][name] = value
        } 

        console.table(cpArticles);

        this.setState({
            ...this.state,
            demand_equipements: cpArticles
        })
    }
    handleChangeCreatable = (option, name, index) => {
        let cpArticles = [].concat(this.state.demand_equipements) 
        let errors = [].concat(this.state.errors)
        if(option){         
            cpArticles[index][name] = option.value
            cpArticles[index].nb_dispo = option.nb_dispo
            cpArticles[index][`${name}Display`] = option
        } else {
            cpArticles[index][name] = ""
            cpArticles[index].nb_dispo = ""
            cpArticles[index][`${name}Display`] = {label: "", value: ""}
        }
        errors[index][name] = "" 
        errors[index].line_quantity = "" 
        this.setState({
            ...this.state,
            demand_equipements: cpArticles,
            errors,
        })
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    validate = () => {
        let demand_equipements = [].concat(this.state.demand_equipements)
        let total = size(demand_equipements)
        let required = [
            "line_quantity",
            "line_equipement",
        ]

        // let errors = []
        let errors = [].concat(this.state.errors)
        let noError = true

        demand_equipements.forEach( (item, index) => {
            required.forEach(field => {
                if( isEmpty(item[field]) && !item[field] ) { 
                    console.log(`${field} is empty`)
                    noError = false
                    errors[index][field] = "Veuillez remplir ce Champ" 
                } else {

                    console.log('====================================');
                    console.log(item, item[field], item.nb_dispo , item[field] > item.nb_dispo );
                    console.log('====================================');
                    // if(field == "line_quantity" && item[field] < 1  ){
                    if(field == "line_quantity" && item[field] > item.nb_dispo  ){
                        errors[index][field] = `Dispo : ${item.nb_dispo}`  // color red
                        noError = false
                    } else {
                        errors[index][field] = "" 
                    }
                }
            })
        })
       console.log('===============in validateArticles=====================');
       console.log({errors});
       console.log('====================================');
        // return {
        //     noError, errors, total
        // }
        this.setState({
            errors: errors,
            noError: noError,
            total: total
        })
        return noError
    }

    handleSubmit = async () => {

        if( this.validate() ){
            let data = Object.assign({}, this.props.DEMAND)
            data.demand_equipements = []

            console.log('====================================');
            console.log("submit demand", {data});
            console.log('====================================');

            this.state.demand_equipements.forEach( e => {
                if(this.props.admin){
                    e.add_by_admin = true
                }
                data.demand_equipements.push(e)
            })
            await this.props.updateLoanDemand(data)

            // // if NoErrors ...
            if(this.props.STATE.demands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.demands.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }

    render() {
        const { EQUIPEMENTS } = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const { tab, total } = this.createAddForm();
        return (
            <Dialog
                title={`Ajouter des articles`}
                close={this.props.handleClose}
                submitAction={!isEmpty(EQUIPEMENTS) && !isEmpty(tab) && this.handleSubmit}
                appBar
                appBarColor="primary"
                maxWidth="md"
            >
            
                {this.state.fetching ?
                    <Spinner />
                : 
                    <>
                        {!isEmpty(this.state.EQUIPEMENTS) ?
                            tab
                            :
                            <Alert severity="warning">
                                Aucun equipement disponible
                            </Alert>
                        }
                        {size(tab) < size(EQUIPEMENTS) &&
                            <Box style={{textAlign: "center"}}>
                                <Button startIcon={<AddCircleOutlineRounded />} variant="contained" onClick={this.handleAddForm} color="secondary">
                                    Ajouter un Equipement
                                </Button>
                            </Box>
                        }
                    </>
                }
            </Dialog>
        );
    }
}

export default EquipDemandUpdateLine;